module.exports = __webpack_public_path__ + "static/tsLogo-97acd3488e8c820e9ccb1d4cf99525a4.png";